import { colors } from './../../../config/styles'

export default {
	button : {
		position			: 'relative',
		display				: 'block',
		width				: '100%',
		fontSize 			: 18,
		textAlign			: 'center',
		cursor				: 'pointer',
		marginLeft 			: 0,
		marginRight 		: 0,
		marginTop 			: 0,
		marginBottom 		: 0,
		paddingLeft 		: 20,
		paddingRight 		: 20,
		paddingTop 			: 5,
		paddingBottom 		: 5,

		color 				: colors.darkGray,
		backgroundColor		: colors.white,
		borderTop			: `1px solid ${colors.lightGray}`,
		borderRight			: `1px solid ${colors.lightGray}`,
		borderBottom		: `1px solid ${colors.lightGray}`,
		borderLeft			: `1px solid ${colors.lightGray}`,
		transition 			: 'color 0.2s ease-in, background-color 0.2s ease-in, border 0.2s ease-in',

		':hover' : {
			color				: colors.white,
			backgroundColor		: colors.black,
			borderTop			: `1px solid ${colors.black}`,
			borderRight			: `1px solid ${colors.black}`,
			borderBottom		: `1px solid ${colors.black}`,
			borderLeft			: `1px solid ${colors.black}`,
		},
		':active' : {
			color				: colors.white,
			backgroundColor		: colors.black,
			borderTop			: `1px solid ${colors.black}`,
			borderRight			: `1px solid ${colors.black}`,
			borderBottom		: `1px solid ${colors.black}`,
			borderLeft			: `1px solid ${colors.black}`,
		}
	},
	disabled : {
		color 				: colors.gray,
		borderTop			: `1px solid ${colors.lighterGray}`,
		borderRight			: `1px solid ${colors.lighterGray}`,
		borderBottom		: `1px solid ${colors.lighterGray}`,
		borderLeft			: `1px solid ${colors.lighterGray}`,
	},
}
